/* eslint-disable react/prop-types */ // TODO: add props
import PT from 'prop-types';
import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { Button, Icon } from 'edrolo-style-guide';
import s from './styles.scss';
import Select from 'react-select-4';

const CollabModal = ({
  isOpen,
  onClose,
  studentOptions,
  selectedStudentIds,
  onSubmit,
}) => {
  const [selectedStudents, setSelectedStudents] = useState(
    studentOptions.filter((s) => selectedStudentIds.includes(s.value))
  );

  useEffect(() => {
    setSelectedStudents(
      studentOptions.filter((s) => selectedStudentIds.includes(s.value))
    );
  }, [selectedStudentIds, studentOptions]);

  const MenuList = ({ innerRef, innerProps, children }) => {
    return (
      <div className={s.menuList} ref={innerRef} {...innerProps}>
        {children}
      </div>
    );
  };

  const Option = ({ innerRef, innerProps, data }) => {
    return (
      <div className={s.option} ref={innerRef} {...innerProps}>
        <option value={data.value} label={data.label} />
      </div>
    );
  };

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Body>
        <header className={s.modalHeader}>
          <h3>Select collaborators</h3>
          <p>
            <strong>Note:</strong>
            &nbsp;only one person needs to submit a response for the group
          </p>
        </header>
        <section className={s.modalBody}>
          <Select
            closeMenuOnSelect={false}
            defaultValue={selectedStudents}
            options={studentOptions}
            isMulti
            isSearchable
            placeholder={
              <>
                <Icon name="search" /> Search...
              </>
            }
            onChange={(e) => setSelectedStudents(e)}
            components={{ Option, MenuList }}
          />
        </section>
        <footer className={s.modalFooter}>
          <Button onClick={onClose} outline>
            Close
          </Button>
          <Button
            onClick={() => {
              onSubmit(selectedStudents);
              onClose();
            }}
          >
            Save
          </Button>
        </footer>
      </Modal.Body>
    </Modal>
  );
};

CollabModal.propTypes = {
  isOpen: PT.bool,
  onClose: PT.func.isRequired,
  onSubmit: PT.func.isRequired,
  studentOptions: PT.arrayOf(
    PT.shape({
      value: PT.number,
      label: PT.string,
    })
  ).isRequired,
  selectedStudentIds: PT.arrayOf(PT.number),
};

CollabModal.defaultProps = {
  isOpen: false,
};

export default CollabModal;
